import React from 'react';
import { motion } from 'framer-motion';
import { SectionTag } from './SectionTag';
import { CONTENT_BLOCKS, CONTENT_IMAGE, CONTENT_TEXTURES } from './salesData';

/**
 * CONTENIDO. Todo lo que acompaña a las recetas para que la ejecución salga
 * bien la primera vez. Lista editorial con filetes + pequeños visuales de
 * proceso intercalados, para que no se lea como un listado plano.
 */
export function ContentSection() {
  return <section id="contenido" className="scroll-mt-24 overflow-hidden bg-cream py-14 sm:py-20" aria-labelledby="content-title" data-id="element-44" data-mp="gu0e79jxkggi">
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-8" data-id="element-45" data-mp="72cr1kueplku">
        <div className="grid gap-10 lg:grid-cols-12 lg:gap-14" data-id="element-46" data-mp="72w2cipjxbpw">
          <div className="lg:col-span-5" data-id="element-47" data-mp="3229rc15z8qo">
            <SectionTag data-id="element-48" data-mp="2yy2g5sejwvs">Además de las recetas</SectionTag>
            <h2 id="content-title" className="mt-4 font-display text-[1.95rem] leading-[1.06] text-charcoal sm:text-[2.7rem]" data-id="element-49" data-mp="3u6aighhju4a4">
              Para que salgan bien la primera vez
            </h2>
            <p className="mt-4 max-w-md font-sans text-[0.95rem] leading-relaxed text-charcoal/65" data-id="element-50" data-mp="3hihi3cdoo983">
              Las cien recetas vienen acompañadas de los fundamentos de fabricación: lo que hace la
              diferencia entre una cookie plana y una New York Cookie gruesa, alta y con el centro
              tierno.
            </p>

            <motion.figure initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.3
          }} transition={{
            duration: 0.32,
            ease: [0.23, 1, 0.32, 1]
          }} className="relative mt-8 overflow-hidden rounded-5xl shadow-bakery" data-id="element-51" data-mp="52np3iftcwmm">
              <img src={CONTENT_IMAGE} alt="Bandeja llena de cookies gruesas recién horneadas con chocolate fundido encima." loading="lazy" decoding="async" className="aspect-[4/3] w-full object-cover" data-id="element-52" data-mp="2j69lrfnpt8" />
            </motion.figure>

            {/* Tres detalles de proceso: masa, relleno y terminación. */}
            <ul className="mt-4 grid grid-cols-3 gap-3 sm:gap-4" data-id="element-53" data-mp="1wr556treqo7z">
              {CONTENT_TEXTURES.map((texture, index) => <motion.li key={texture.id} initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              amount: 0.4
            }} transition={{
              duration: 0.26,
              ease: [0.23, 1, 0.32, 1],
              delay: index * 0.04
            }} data-id="element-54" data-mp="1rxk7l2tq7w9b" data-mpi={index}>
                  <img src={texture.image} alt={texture.alt} loading="lazy" decoding="async" className="aspect-square w-full rounded-3xl object-cover shadow-bakery-sm" data-id="element-55" data-mp="1427qt1qbhbki" />
                </motion.li>)}
            </ul>
          </div>

          <ul className="grid gap-x-12 lg:col-span-7 sm:grid-cols-2" data-id="element-56" data-mp="35z889q1i7m2w">
            {CONTENT_BLOCKS.map((block, index) => <motion.li key={block.id} initial={{
            opacity: 0,
            y: 12
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.4
          }} transition={{
            duration: 0.28,
            ease: [0.23, 1, 0.32, 1],
            delay: Math.min(index, 4) * 0.035
          }} className="flex flex-col border-b border-warm/80 py-5" data-id="element-57" data-mp="3fpb746vb3u95" data-mpi={index}>
                <span className="flex h-7 w-7 items-center justify-center rounded-full bg-gold-pale font-sans text-[0.6rem] font-bold tabular-nums text-gold-deep" data-id="element-58" data-mp="2x0wjzuo410dm">
                  {String(index + 1).padStart(2, '0')}
                </span>
                <h3 className="mt-3 font-display text-[1.1rem] leading-tight text-charcoal sm:text-[1.3rem]" data-id="element-59" data-mp="g9mwtyufnb4o">
                  {block.title}
                </h3>
                <p className="mt-2 font-sans text-[0.88rem] leading-relaxed text-charcoal/60" data-id="element-60" data-mp="euu1p2jzxz1p">
                  {block.body}
                </p>
              </motion.li>)}
          </ul>
        </div>
      </div>
    </section>;
}